<ui-dialog width="sm">
  <ng-container dialog-title> Fehler Webservice </ng-container>

  <ng-container dialog-content>
    <div class="border border-solid rounded p-4 flex items-center gap-4">
      <div><mat-icon svgIcon="cp-info" class="icon-info-error" /></div>
      <div class="text-cp-error-100 break-words">
        {{ message ?? 'Unbekannter Fehler' }}
      </div>
    </div>
  </ng-container>
</ui-dialog>
